import React, { FunctionComponent } from 'react';
import { ReactComponent as SmartQareLogoAsset } from '../../assets/images/smartqare-logo.svg';
import { ReactComponent as SmartQareQMarkAsset } from '../../assets/images/smartqare-q-mark.svg';
import { BRAND_LOGO_LABEL, BRAND_MARK_LABEL } from '../../branding/constants';

export type BrandLogoVariant = 'full' | 'mark';
export type BrandLogoSize = 'sm' | 'md' | 'lg';

type BrandLogoProps = {
  variant?: BrandLogoVariant;
  size?: BrandLogoSize;
  decorative?: boolean;
  className?: string;
};

type BrandLogoDimensions = {
  width: number;
  height: number;
};

const logoDimensions: Record<BrandLogoVariant, Record<BrandLogoSize, BrandLogoDimensions>> = {
  full: {
    sm: { width: 160, height: 29 },
    md: { width: 220, height: 40 },
    lg: { width: 280, height: 51 },
  },
  mark: {
    sm: { width: 32, height: 39 },
    md: { width: 48, height: 58 },
    lg: { width: 56, height: 68 },
  },
};

export const BrandLogo: FunctionComponent<BrandLogoProps> = ({
  variant = 'full',
  size = 'md',
  decorative = false,
  className,
}) => {
  const Component = variant === 'mark' ? SmartQareQMarkAsset : SmartQareLogoAsset;
  const ariaLabel = variant === 'mark' ? BRAND_MARK_LABEL : BRAND_LOGO_LABEL;
  const dimensions = logoDimensions[variant][size];
  const accessibilityProps = decorative
    ? { 'aria-hidden': true, role: 'presentation' as const }
    : { 'aria-label': ariaLabel, role: 'img' as const };

  return (
    <Component
      className={className}
      width={dimensions.width}
      height={dimensions.height}
      focusable="false"
      {...accessibilityProps}
    />
  );
};
